import React from 'react';

export default function SpatialGridResearch() {
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState('');

  React.useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage('');
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  const handleSubmit = async () => {
    const name = document.getElementById('name').value;
    const company = document.getElementById('company').value;
    const email = document.getElementById('email').value;
    const purpose = document.getElementById('purpose').value;
    const message = document.getElementById('message').value;

    if (!name || !email || !message || !company) {
      alert('Please fill in all required fields.');
      return;
    }

    setIsSubmitting(true);

    try {
      console.log('Sending request to API...');
      console.log('Payload:', { name, company, email, purpose, message });

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}email/research-inquiry`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name,
            company,
            email,
            purpose,
            message,
          }),
        }
      );


      console.log('Response status:', response.status);
      console.log('Response:', response);

      if (response.ok) {
        const data = await response.json();
        console.log('Success response:', data);
        setSuccessMessage(
          data.message ||
            'Thank you for your request. Our team will contact you shortly.'
        );

        // Reset form
        document.getElementById('name').value = '';
        document.getElementById('company').value = '';
        document.getElementById('email').value = '';
        document.getElementById('purpose').value = '';
        document.getElementById('message').value =
          "I'm interested in discussing access to SpatialGrid Research.";
      } else {
        const errorData = await response
          .json()
          .catch(() => ({ message: 'Unknown error' }));
        console.error('Error response:', errorData);
        alert(
          `Error: ${errorData.message || 'Failed to submit request. Please try again.'}`
        );
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      console.error('Error details:', error.message);
      alert(
        'An error occurred while submitting your request. Please try again later.'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen mt-28">
      {/* Toast Notification */}
      {successMessage && (
        <div className="fixed top-5 right-5 z-[999999]">
          <div className="bg-[#1E1F22] border border-[#6bee2a] rounded-lg shadow-2xl p-4 flex items-start gap-3 min-w-80 max-w-md">
            <div className="flex-shrink-0">
              <svg
                className="w-6 h-6 text-[#6bee2a]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
              </svg>
            </div>
            <div className="flex-1">
              <p className="text-[#FFFFFF] font-semibold mb-1">Success!</p>
              <p className="text-[#A7A7A7] text-sm">{successMessage}</p>
            </div>
            <button
              onClick={() => setSuccessMessage('')}
              className="flex-shrink-0 text-[#A7A7A7] hover:text-[#FFFFFF]"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      )}

      <main className="max-w-6xl mx-auto px-5 py-10">
        {/* Header Section */}
        <section className="text-center mb-10">
          <h1 className="text-4xl font-bold mb-2 text-[#FFFFFF] font-jakarta">
            Spatial Grid Research
          </h1>
          <p className="text-[#A7A7A7] text-base md:text-lg">
            Access to SpatialGrid Research is restricted and requires prior
            approval.
          </p>
        </section>

        {/* Info Section */}
        <section className=" rounded-lg mb-8  max-w-4xl text-lg ">
          <h2 className="text-2xl font-bold mt-0 mb-4 text-[#FFFFFF] font-jakarta">
            Restricted Access
          </h2>
          <p className="leading-relaxed mb-4 text-[#A7A7A7]">
            The Spatial Grid Research materials associated with this section
            contain
            <strong className="text-[#FFFFFF]">
              {' '}
              confidential and proprietary information{' '}
            </strong>
            developed by <strong className="text-[#FFFFFF]">
              Spatial
            </strong>{' '}
            <strong className="text-[#FFFFFF]">Grid</strong>.
          </p>

          <p className="leading-relaxed mb-4 text-[#A7A7A7]">
            To protect our intellectual property, full SpatialGrid Research
            details are shared only with approved individuals or organizations.
          </p>
          <p className="leading-relaxed mb-4 text-[#A7A7A7]">
            If you are interested in discussing SpatialGrid Research,
            collaboration opportunities, or access requests, please reach out
            using the form below.
          </p>
        </section>

        {/* Contact Section */}
        <section className="bg-[#1E1F22] p-8 rounded-lg mb-8">
          <h2 className="text-2xl font-bold mt-0 mb-4 text-[#FFFFFF] font-jakarta">
            Request to Discuss Spatial Grid Research
          </h2>
          <p className="mb-5 text-[#A7A7A7]">
            Submit your details and our team will contact you shortly.
          </p>

          <div>
            <div className="flex flex-col mb-4">
              <label htmlFor="name" className="text-sm mb-1.5 text-[#A7A7A7]">
                Full Name <span className="text-[#EE2B2A]">*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                className="px-3 py-2.5 rounded bg-[#35373a] text-base text-[#FFFFFF] outline-none"
              />
            </div>

            <div className="flex flex-col mb-4">
              <label
                htmlFor="company"
                className="text-sm mb-1.5 text-[#A7A7A7]"
              >
                Company / Organization <span className="text-[#EE2B2A]">*</span>
              </label>
              <input
                type="text"
                id="company"
                name="company"
                className="px-3 py-2.5 rounded bg-[#35373a] text-base text-[#FFFFFF] outline-none"
              />
            </div>

            <div className="flex flex-col mb-4">
              <label htmlFor="email" className="text-sm mb-1.5 text-[#A7A7A7]">
                Email Address <span className="text-[#EE2B2A]">*</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                className="px-3 py-2.5 rounded bg-[#35373a] text-base text-[#FFFFFF] outline-none"
              />
            </div>

            <div className="flex flex-col mb-4">
              <label
                htmlFor="purpose"
                className="text-sm mb-1.5 text-[#A7A7A7]"
              >
                Purpose of Inquiry
              </label>
              <select
                id="purpose"
                name="purpose"
                className="px-3 py-2.5 rounded bg-[#35373a] text-base text-[#FFFFFF] outline-none"
              >
                <option value="">Select an option</option>
                <option value="collaboration">Research Collaboration</option>
                <option value="commercial">Commercial Use</option>
                <option value="academic">Academic Interest</option>
                <option value="general">General Inquiry</option>
              </select>
            </div>

            <div className="flex flex-col mb-4">
              <label
                htmlFor="message"
                className="text-sm mb-1.5 text-[#A7A7A7]"
              >
                Message <span className="text-[#EE2B2A]">*</span>
              </label>
              <textarea
                id="message"
                name="message"
                rows="4"
                // defaultValue="I'm interested in discussing access to SpatialGrid Research."
                className="px-3 py-2.5 rounded bg-[#35373a] text-base text-[#FFFFFF] outline-none"
              />
            </div>

            <button
              onClick={handleSubmit}
              disabled={isSubmitting}
              className="bg-[#EE2B2A] text-white border-none px-5 py-3 text-base rounded cursor-pointer mt-2.5 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            >
              {isSubmitting && (
                <svg
                  className="animate-spin h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
              )}
              {isSubmitting ? 'Submitting...' : 'Submit Request'}
            </button>
          </div>
        </section>
      </main>
    </div>
  );
}
